import EmailAddress from "_shared/email-addresses/email-address";

export default class ResetPasswordRequestAPIRequest {
  public email: string;

  public constructor(email: EmailAddress) {
    this.email = email.value;
  }
}
